<template>
  <v-text-field
    v-model="input"
    :dense="dense"
    @keypress="isNumber($event)"
    ref="input"
    v-bind="$attrs"
    :value="input"
    :type="type"
    @keyup.enter="$emit('enter')"
    outlined
    :rules="getRules"
    @input="$emit('input', input)"
  >
    <template v-slot:append>
      <v-tooltip bottom v-if="help">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="" x-small>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ help }}</span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
import { getRules } from "../../../assets/js/common.js";
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    help: {
      type: String,
      default: "",
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: "",
    },
    customRules: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    getRules() {
      let { customRules, rules, settings, input } = this;
      if (customRules.length > 0) return customRules;
      if (rules == "" && input == "") return [];
      let { maxChar, minChar } = settings;
      if ((minChar === "" || minChar == undefined) && maxChar) minChar = 0;
      rules = getRules(rules);
      let fieldType = this.type == "number" ? "digits" : "characters";
      if (maxChar && minChar == maxChar && input) {
        rules.push(
          (v) =>
            v.toString().length == maxChar ||
            this.t(`Please enter ${maxChar} ${fieldType}.`)
        );
      }
      if (maxChar && minChar != maxChar && input) {
        rules.push(
          (v) =>
            v.toString().length >= minChar ||
            this.t(`Field must be more than ${minChar} ${fieldType}.`)
        );
        rules.push(
          (v) =>
            v.toString().length <= maxChar ||
            this.t(`Field must be less than ${maxChar} ${fieldType}.`)
        );
      }
      return rules;
    },
  },
  methods: {
    isNumber: function (evt) {
      let val = this.input || "";
      let text = val.replace(/^\D+/g, "");
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (!text && charCode == 49 && this.type == "phone") {
        evt.preventDefault();
        return;
      }
      if (this.type != "amount") return true;
      evt = evt ? evt : window.event;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  mounted() {
    this.input = this.value;
  },
};
</script>
